import { Dropdown as AntDropdown } from 'antd';
import styled from 'styled-components';

export const Dropdown = styled(AntDropdown)``;
